import { IWorkLoggingConfig } from "@wingspanhq/payments/dist/interfaces";
import {
  IWorkLoggingConfigResponse,
  IWorkLoggingConfigUpdateRequest
} from "@wingspanhq/payments/dist/interfaces/api/workLoggingConfig";
import { servicePayments } from "./servicePayments";

// Payer: read own work log config
export async function getWorkLogConfig(): Promise<IWorkLoggingConfigResponse> {
  const response = await servicePayments.get("/work-logging-config");
  return response.data;
}

// Payee: read payer's work log config
export async function getWorkLogConfigForPayee(
  payerId: string
): Promise<IWorkLoggingConfigResponse> {
  const response = await servicePayments.get(
    `/payer/${payerId}/work-logging-config`
  );
  return response.data;
}

// Payer: update own work log config
export async function updateWorkLogConfig(
  request: IWorkLoggingConfigUpdateRequest
): Promise<IWorkLoggingConfig> {
  const response = await servicePayments.patch("/work-logging-config", request);
  return response.data;
}
